
/**
 * https://developerx.atlassian.net/browse/CS-5355
 *
 * Created at : 26 January 2022           Updated at : 26 July 2022
 * Created by : Risman Abdilah            Updated by : Hafiizh Ghulam
 *
 * Version 2.3.0
 */

import Vue from "vue";
import $ from "jquery";
import filters from "@/filters";
import directives from "@/directives";
import Component from "vue-class-component";

import { AxiosResponse } from "axios";
import { Prop, Watch } from "vue-property-decorator";
import { Action, Mutation, State } from "vuex-class";

import { ChannelMessageModel, ChannelModel } from "@/models/messaging.model";
import toast from "@/functions/toast.function";

@Component({
  filters,
  directives,
})
export default class PersonalChat extends Vue {
  /* VUEX */

  /* ACTIONS */
  @Action("actionGetMessagingPersonal", { namespace: "messaging" })
  private actionGetMessagingPersonal: any;
  @Action("actionGetCandidates", { namespace: "messaging" })
  private actionGetCandidates: any;
  @Action("actionGetDetailChannel", { namespace: "messaging" })
  private actionGetDetailChannel: any;
  @Action("actionSendMessage", { namespace: "messaging" })
  private actionSendMessage: any;

  /* STATE */
  @State("school", { namespace: "academy" })
  private school: any;
  @State("array_channel", { namespace: "messaging" })
  private array_channel: Array<ChannelModel>;
  @State("detail_channel", { namespace: "messaging" })
  private detail_channel: ChannelModel;
  @State("array_candidates", { namespace: "messaging" })
  private array_candidates: Array<any>;
  @State("array_messages", { namespace: "messaging" })
  private array_messages: Array<ChannelMessageModel>;

  /* MUTATIONS */
  @Mutation("setDetailChannel", { namespace: "messaging" })
  private setDetailChannel: any;

  @Watch("school_id", { deep: true, immediate: true })
  private onChangeSchoolId(val: any, oldVal: any) {
    this.getData();
  }

  @Prop({default: false})
  private canAccess: boolean;
  @Prop({default: false})
  private canSubscriptionAccess: boolean;
  @Prop({default: () => {}})
  private openModalPayment: () => {};

  @Watch("canSubscriptionAccess", { deep: true, immediate: true })
  private onChangeCanSubscriptionAccess(val: any, oldVal: any) {
    this.getData();
  }
  @Watch("canAccess", { deep: true, immediate: true })
  private onChangeAccess(val: any, oldVal: any) {
    this.getData();
  }

  /* INITIALIZATION */

  private get school_id() {
    return this.school.id;
  }

  private get isChannelId() {
    const { school_id, student_id } = this.detail_channel;
    return school_id && student_id;
  }

  private isCreate = false;
  private candidateValue = "";
  private chat_message = "";

  private created() {
    this.isCreate = false;
  }

  // METHODS
  private getData() {
    if (this.school_id) {
      if (this.canAccess) {
        if (this.canSubscriptionAccess) {
          this.actionGetMessagingPersonal({
            params: {
              school_id: this.school_id,
            },
          });
        }
      }
    }
  }
  private actionNewChat() {
    if (this.canAccess) {
      if (this.canSubscriptionAccess) {
        if (!this.isCreate) {
          this.actionGetCandidates({
            params: {
              school_id: this.school_id,
              loader: false,
            },
          });
        }
        this.isCreate = !this.isCreate;
      } else {
        this.openModalPayment();
      }
    } else {
      toast.error(this.$i18n.t("feature_not_available"));
    }
  }

  private onSendMessage() {
    if (this.canAccess) {
      if (this.canSubscriptionAccess) {
        this.actionSendMessage({
          params: { chat: this.chat_message },
          callback: (channel: ChannelMessageModel) => {
            this.chat_message = "";
            this.actionGetMessagingPersonal({
              params: {
                school_id: this.school_id,
              },
            });
            this.actionGetDetailChannel({
              params: { id: channel.id },
              callback: (data: AxiosResponse) => {
                this.scrollToBottom();
              },
            });
          },
        });
      } else {
        this.openModalPayment();
      }
    } else {
      toast.error(this.$i18n.t("feature_not_available"));
    }
  }

  private onClickChannel(item: ChannelModel, index: number) {
    const width = $(window).width();

    this.actionGetDetailChannel({
      params: item,
      callback: (data: AxiosResponse) => {},
    });

    if (width && width > 600) {
      $(".PersonalChat .ChannelItem").removeClass("active");
      const channelItem = $(`.PersonalChat #item${index}.ChannelItem`);
      channelItem.addClass("active");
    } else {
      $(".PersonalChat .Channel").css({
        display: "none",
      });
      $(".PersonalChat .ChannelDetail").css({
        display: "flex",
      });
      $(".PersonalChat .ChannelDetail .back").css({
        display: "flex",
      });
    }

    this.scrollToBottom();
  }

  private actionBack() {
    this.setDetailChannel(new ChannelModel());

    $(".PersonalChat .ChannelDetail").css({
      display: "none",
    });
    $(".PersonalChat .Channel").css({
      display: "block",
    });
  }

  private actionClickCandidate(item: any) {
    const { id, first_name, last_name, phone, photo, channel_id } = item;

    if (channel_id) {
      this.actionGetDetailChannel({
        params: { id: channel_id },
        callback: (data: AxiosResponse) => {},
      });
    } else {
      const channel = Object.assign({}, {
        id: 0,
        school_id: this.school_id,
        student_id: id,
        student_name: first_name + " " + last_name,
        student_photo: photo,
        student_phone: phone,
        is_deleted: false,
      })
      this.setDetailChannel(channel);
    }
    this.isCreate = false;
    this.candidateValue = "";
  }

  private searchCandidates(event: any) {
    const { value } = event.target;
    if (value) {
      this.actionGetCandidates({
        params: {
          school_id: this.school.id,
          search: value,
          loader: false,
        },
      });
    } else {
      this.actionGetCandidates({
        params: {
          school_id: this.school.id,
          loader: false,
        },
      });
    }
  }

  private isReadChat(chat: ChannelMessageModel) {
    if (chat.sender === "student" && !chat.is_readed) {
      return true;
    }

    return false;
  }

  private scrollToBottom() {
    /**
     * Scroll to bottom to get the last of messages
     * Get element by id => chat
     * animate element scrolTop to scrollHeight
     */
    setTimeout(() => {
      const elchat = document.getElementById("chat");

      $("#chat").animate({ scrollTop: elchat?.scrollHeight }, 300);
    }, 600);
  }
}
